import React from 'react';
import './Contact.css';

const Contact = () => {
  return (
    <div className="ub-contact">
      <h1>Contact Us</h1>

      <div className="contact-container">
        <div className="contact-info">
          <h2>Our Location</h2>
          <div className="map-container">
            <iframe
              title="UbResources Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31734.124370385853!2d6.838088039550787!3d6.162146200000007!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x104391bd7b90a0c9%3A0x374c42a0227acbb!2sBUILDING%20MATERIALS%20INTERNATIONAL%20MARKET%2C%20OGIDI!5e0!3m2!1sen!2suk!4v1744648466809!5m2!1sen!2suk"
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>

          <div className="contact-details">
            <h3>Get in Touch</h3>
            <div className="detail-item">
              <i className="fas fa-envelope"></i>
              <p>urbanbuilds@workmail.com</p>
            </div>
            <div className="detail-item">
              <i className="fas fa-phone"></i>
              <p>+2347031901705</p>
            </div>
            <div className="detail-item">
              <i className="fas fa-map-marker-alt"></i>
              <p>Building Materials, Ogidi, Anambra, Nigeria.</p>
            </div>
          </div>

          <div className="whatsapp-contact">
            <h3>Chat with us on WhatsApp</h3>
            <a href="https://wa.me/2347031901705" target="_blank" rel="noopener noreferrer">
              <button className="whatsapp-btn">
                <i className="fab fa-whatsapp"></i> WhatsApp Us
              </button>
            </a>
          </div>
        </div>

        <div className="contact-form">
          <h2>Send Us a Message</h2>
          <iframe
            src="https://tawk.to/chat/680bd6cf7161c519104dc907/1ipn3u6da"
            width="100%"
            height="500px"
            frameBorder="0"
            title="Tawk.to Contact Form"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default Contact;
